import { API_URL } from '../../../app-config/constants';
import { MessageSettingDto } from '../../../types/MessageSettingDto';
import { get, put } from '../request';

const ENTRY = `${API_URL}/message-settings`;

getAll.operation = 'READ';
export function getAll(): Promise<MessageSettingDto> {
    return get(ENTRY);
}

save.invalidates = ['getAll'];
export function save(updatedSettings: MessageSettingDto): Promise<MessageSettingDto> {
    return put(ENTRY, { postData: updatedSettings });
}
